import React, { Component } from 'react';
import {withTranslation} from "react-i18next";

import {withSuspense} from './util/WithSuspense.js';

const SEP=".0q."; // Separator between seat group name and seat name in the seat id of the svg.

// This component encapsulates the seat map for La Marlagne. Refer to NadheoPlaceMap for interface documentation.
class PlaceMarlagne extends Component {
  constructor (props) {
    super(props);
    this.state = {zoneAVisible: false,
                  zoneBVisible: false,
                  zoneCVisible: false,
                  zoneDVisible: false};
    this.handleClick = this.handleClick.bind(this);
    this.hideZones = this.hideZones.bind(this);
    this.handleZoneClick = this.handleZoneClick.bind(this);
  }

  getColour(seatState, seatCategory){
    if (seatState === "free") {
      let seatCategories = this.props.seats.seatCategories;
      if (seatCategories.length <= 1) {
        return (this.props.freeColour === undefined)? "green": this.props.freeColour;
      } else {
        seatCategories.sort();
        let idx = seatCategories.findIndex((item)=>(item === seatCategory));
        return this.getColourGradient(this.props.freeColour, this.props.freeColourLastCategory,
          seatCategories.length, idx);
      }
    }
    if (seatState === "paid") return (this.props.paidColour === undefined)? "gray": this.props.paidColour;
    if (seatState === "booked") return (this.props.bookedColour === undefined)? "lightgray": this.props.bookedColour;
    if (seatState === "highlighted") return (this.props.highlightedColour === undefined)? "red": this.props.highlightedColour;
    if (seatState === "notforsale") return(this.props.notforsaleColour === undefined)? "black": this.props.notforsaleColour;
    if (seatState === "isolated") return (this.props.isolatedColour === undefined)? "green": this.props.isolatedColour;
    if (seatState === "buffered") return (this.props.bufferedColour === undefined)? "yellow": this.props.bufferedColour;
  }
  getColourGradient(startColour, endColour, nbrOfColour, index) {
    if (startColour === undefined) startColour = "#008000"; // Green
    if (endColour === undefined) endColour = "#33ff33";
    if (index === 0) return startColour;
    if (index === nbrOfColour-1) return endColour;
    let redStartColour = parseInt(startColour.substr(1,2), 16);
    let greenStartColour = parseInt(startColour.substr(3,2), 16);
    let blueStartColour = parseInt(startColour.substr(5,2), 16);
    let redStep = (parseInt(endColour.substr(1, 2), 16) - redStartColour)/nbrOfColour;
    let greenStep = (parseInt(endColour.substr(3, 2), 16) - greenStartColour)/nbrOfColour;
    let blueStep = (parseInt(endColour.substr(5, 2), 16) - blueStartColour)/nbrOfColour;
    return "#"+Math.abs(redStartColour+redStep*index).toString(16).padStart(2, '0')+
      Math.abs(greenStartColour+greenStep*index).toString(16).padStart(2, '0')+
      Math.abs(blueStartColour+blueStep*index).toString(16).padStart(2, '0');
  }

  // React on click event on the SVG map
  handleClick(e) {
    
    if (undefined !== this.props.onSeatClick) {
      let groupName = e.currentTarget.id.slice(0, e.currentTarget.id.indexOf(SEP));
      let seatName = e.currentTarget.id.slice(e.currentTarget.id.indexOf(SEP) + SEP.length);
      this.props.onSeatClick(groupName, seatName, e);
    }
  }

  handleZoneClick(e) {
    switch (e.currentTarget.id) {
      case "zoneA":
        this.setState({zoneAVisible: true}); break;
      case "zoneB":
        this.setState({zoneBVisible: true}); break;
      case "zoneC": 
        this.setState({zoneCVisible: true}); break;
      case "zoneD": 
        this.setState({zoneDVisible: true}); break;
      default: 
        console.log("unknown zone: " + e.currentTarget.id);
    }
  }

  hideZones() {
    this.setState({zoneAVisible: false,
                   zoneBVisible: false,
                   zoneCVisible: false,
                   zoneDVisible: false});
  }

  isLargeScreen(){
    return window.innerWidth > 768;
  }

  /**
   * Get the component for the zones. 
   * The zone component is only shown on small screen. It is to be added last (after the seats) so that
   * the zone can be clicked and the seats cannot.
   */
  getZones() {
    if (this.isLargeScreen()) return "";
    return (
        <g>
        <g id="zoneA" opacity="0" onClick={this.handleZoneClick}>
          <path d="M942,1451 a560,560   0 0,1 278,-436 L750,201 a1500,1500 0 0,0 -744,1168 z" fill="context-fill"/>
        </g>
        <g id="zoneB" opacity="0" onClick={this.handleZoneClick}>
          <path d="M1780,1015 a560,560 0 0,0 -560,0 L750,201 a1500,1500 0 0,1 1500,0 z" fill="context-fill"/>
        </g>
        <g id="zoneC" opacity="0" onClick={this.handleZoneClick}>
          <path d="M2058,1451 a560,560 0 0,0 -278,-436 L2250,201 a1500,1500 0 0,1 744,1168 z" fill="context-fill"/>
        </g>
        <g id="zoneD" opacity="0" onClick={this.handleZoneClick}>
          <path d="M1020,1500 a480,480 0 1,1  960,0 z" fill="context-fill"/>
        </g>
        </g>
        );
  }

  // Returns a SVG component representing the legend
  getLegend() {
    if (!this.props.showLegend) return "";
    return (
      <div className="legende-complete">
        {this.props.legend.map((item, idx, array)=>
            ((idx % 2 === 0)? 
              (
                <div key={idx} className="legende-separation">
                  <div className="legende">
                    <div className="disponibilite" style={{border: "1px solid black", "backgroundColor": item.Colour}}/>
                    <p>{item.Text}</p>
                  </div>
                  {(array.length > idx+1)?(
                      <div className="legende">
                        <div className="disponibilite" style={{border: "1px solid black", "backgroundColor": array[idx+1].Colour}}/>
                        <p>{array[idx+1].Text}</p>
                      </div>):""}
                </div>):""))}
      </div>);
  }

  render() {
    const { t } = this.props;
    let selectZoneText= "";
    if (!this.isLargeScreen()) 
      selectZoneText =  <div className="notes"><p><strong>{t("Sélectionnez la zone")}</strong></p></div>;
    // Compute seat colour
    let seatColour = {};
    for (let seat of this.props.seats.placeSeats)
    {
      let key = seat["group.name"]+SEP+seat.name;
      seatColour[key] = this.getColour(this.props.seats.getSeatStatus(seat["group.name"], seat.name),
                                       this.props.seats.getSeatCategory(seat["group.name"], seat.name));
    }
    if (this.state.zoneAVisible || 
        this.state.zoneBVisible ||
        this.state.zoneCVisible ||
        this.state.zoneDVisible) {
      let backToGlobalViewButton= (
          <div className="notes">
            <button onClick={this.hideZones}><strong>{t("Retour à la vue globale")}</strong></button>
          </div>);
      return (
        <React.Fragment>
          {backToGlobalViewButton}
          <div className="ensemble-salle">
            {this.getLegend()}
            <div className="plan-salle" >
            {(this.state.zoneAVisible)? 
              (<ZoneAPanel onDone={this.hideZones} 
                          onSeatClick={this.handleClick}
                           onMouseSeatEnter={this.props.onMouseSeatEnter}
                           onMouseSeatLeave={this.props.onMouseSeatLeave}
                          SEP={SEP}
                          seatColour={seatColour}
                          width={this.props.width}/>):""}
            {(this.state.zoneBVisible)?
              (<ZoneBPanel onDone={this.hideZones}
                          onSeatClick={this.handleClick}
                           onMouseSeatEnter={this.props.onMouseSeatEnter}
                           onMouseSeatLeave={this.props.onMouseSeatLeave}
                          onHandiSeatClick={this.props.onHandiSeatClick}
                          SEP={SEP}
                          seatColour={seatColour}
                          width={this.props.width}/>):""}
            {(this.state.zoneCVisible)?
              (<ZoneCPanel onDone={this.hideZones}
                          onSeatClick={this.handleClick}
                           onMouseSeatEnter={this.props.onMouseSeatEnter}
                           onMouseSeatLeave={this.props.onMouseSeatLeave}
                          SEP={SEP}
                          seatColour={seatColour}
                          width={this.props.width}/>):""}
            {(this.state.zoneDVisible)?
              (<ZoneDPanel onDone={this.hideZones}
                          onSeatClick={this.handleClick}
                           onMouseSeatEnter={this.props.onMouseSeatEnter}
                           onMouseSeatLeave={this.props.onMouseSeatLeave}
                          SEP={SEP}
                          seatColour={seatColour}
                          width={this.props.width}/>):""}
            </div>
          </div>
        </React.Fragment>);
    }
    let div = (
        <div style={{ width: this.props.width }}>
          {selectZoneText}
          <div className="ensemble-salle">
      {this.getLegend()}
      <div className="plan-salle" >
      <svg viewBox="0 0 3000 1700"  >
  <defs>
    {getSeatSymbol()}
    <g id="door" width="200" height="50">
      <path stroke="black" strokeWidth="3" fill="none" d="M0,70 L70,0 M200,70 L130,0 "/>
      <path stroke="gray" strokeWidth="3" strokeDasharray="5 5" strokeDashoffset="5" fill="none" d="M70,0 A100,100 0 0,1 100,70 M130,0 A100,100 0 0,0 100,70"/>
    </g>
     <g
        id="handi"
        transform="translate(-34.755357,-151.55197)"
        fill="none"
        stroke="#000000"
        strokeWidth="5">
       <circle
          r="9.9480267"
          cx="60"
          cy="162"
          opacity="1"/>
       <path
          d="M 94.740599,224 A 29.740599,29.740599 0 0 1 68.411797,253.54425 29.740599,29.740599 0 0 1 36.042194,230.77854 29.740599,29.740599 0 0 1 54.944211,196.011"
          opacity="1"/>
       <path
          d="m 61.010495,171.64249 5.401971,44.80459 31.458538,-0.31777 6.990786,31.14078 4.60756,-1.7477 v 0 0.15888"
          opacity="1"/>
       <path
          d="m 63.393719,191.02604 17.794726,-0.63553"
          opacity="1"/>
     </g>
     <g id="handi-seat">
       <g transform="scale(0.45 0.45) translate(130,120) rotate(180) " >
         <use href="#seat" fill="white"/>
       </g>
       <g transform="scale(0.4 0.4) translate(30 10)"><use href="#handi"/></g>
     </g>
  </defs>

  <line x1="0" y1="1500" x2="3000" y2="1500" stroke="black" strokeWidth="1" fill="none"/>
  <circle cx="1500" cy="1500" r="1500" stroke="black" strokeWidth="1" fill="none"/>
  <g transform=" translate(92 1250)">
    <g transform="rotate(96)">
      <use href="#door"/>
    </g>
  </g>
  <g transform=" translate(908 198)">
    <g transform="rotate(152)">
      <use href="#door"/>
    </g>
  </g>
  <g transform=" translate(2260 290)">
    <g transform="rotate(208)">
      <use href="#door"/>
    </g>
  </g>
  <g transform=" translate(2930 1450)">
    <g transform="rotate(-96)">
      <use href="#door"/>
    </g>
  </g>
  <text x="1025" y="1700" fontSize="200" fill="black" textLength="1000">{t("SCENE")}</text>
  <line x1="650" y1="1500" x2="650" y2="1750" stroke="black" strokeWidth="1"/>
  <line x1="2350" y1="1500" x2="2350" y2="1750" stroke="black" strokeWidth="1"/>
  <ZoneA onSeatClick={this.handleClick}
         onMouseSeatEnter={this.props.onMouseSeatEnter}
         onMouseSeatLeave={this.props.onMouseSeatLeave}
         seatColour={seatColour}
         SEP={SEP}/>
  <ZoneB onSeatClick={this.handleClick}
         onMouseSeatEnter={this.props.onMouseSeatEnter}
         onMouseSeatLeave={this.props.onMouseSeatLeave}
         onHandiSeatClick={this.props.onHandiSeatClick}
         seatColour={seatColour}
         SEP={SEP}/>
  <ZoneC onSeatClick={this.handleClick}
         onMouseSeatEnter={this.props.onMouseSeatEnter}
         onMouseSeatLeave={this.props.onMouseSeatLeave}
         seatColour={seatColour}
         SEP={SEP}/>
  <ZoneD onSeatClick={this.handleClick}
         onMouseSeatEnter={this.props.onMouseSeatEnter}
         onMouseSeatLeave={this.props.onMouseSeatLeave}
         seatColour={seatColour}
         SEP={SEP}/>

  {this.getZones()}
</svg></div></div></div>) ;
    return div;
  }
}
function getSeatSymbol() {
  return (
      <symbol id="seat" stroke="black">
        <path d="M40,10 l65,0 c20,0 30,0 30,100 l-125,0 c0,-100 10,-100 30,-100"/>
        <path d="M10,110 a20,20 0 0,0 20,20 l85,0 a20,20 0 0,0 20,-20"/>
      </symbol>
  );
}

const Seat = class Seat extends Component {
  render() {
    const { groupName, seatName, seatColour, onClick} = this.props;
    let seatId = groupName + SEP + seatName;
    return (
      <React.Fragment>
        <g transform="scale(0.45 0.45)"
           onMouseEnter={(e)=>this.props.onMouseSeatEnter(groupName, seatName, e.clientX, e.clientY)}
           onMouseLeave={()=>this.props.onMouseSeatLeave(groupName, seatName)}>
          <g transform=" translate(130,120) rotate(180) ">
            <use href="#seat" id={seatId} fill={seatColour} stroke="black" onClick={onClick}/>
          </g>
          <text x="60" y="60" id={seatId} fontSize="36" textAnchor="middle" cursor="default" onClick={onClick}>{groupName}{seatName}</text>
        </g>
      </React.Fragment>
    );
  }
};

const ZoneAPanel = class ZoneAPanel extends Component {

  render() {
    return (
    <div style={{ width: this.props.width }}>
      <svg viewBox="0 0 1170 1150">
        <defs>
          {getSeatSymbol()}
        </defs>
        <g transform="translate(-30 -260)">
          <ZoneA onDone={this.props.hideZones}
                 onSeatClick={this.props.onSeatClick}
                 onMouseSeatEnter={this.props.onMouseSeatEnter}
                 onMouseSeatLeave={this.props.onMouseSeatLeave}
                 SEP={this.props.SEP}
                 seatColour={this.props.seatColour}/>
        </g>
      </svg>
    </div>);
  }
}

const ZoneBPanel = class ZoneBPanel extends Component {
  render() {
    return (
    <div style={{ width: this.props.width }}>
      <svg viewBox="0 0 1200 970">
        <defs>
          {getSeatSymbol()}
     <g
        id="handi"
        transform="translate(-34.755357,-151.55197)"
        fill="none"
        stroke="#000000"
        strokeWidth="5">
       <circle
          r="9.9480267"
          cx="60"
          cy="162"
          opacity="1"/>
       <path
          d="M 94.740599,224 A 29.740599,29.740599 0 0 1 68.411797,253.54425 29.740599,29.740599 0 0 1 36.042194,230.77854 29.740599,29.740599 0 0 1 54.944211,196.011"
          opacity="1"/>
       <path
          d="m 61.010495,171.64249 5.401971,44.80459 31.458538,-0.31777 6.990786,31.14078 4.60756,-1.7477 v 0 0.15888"
          opacity="1"/>
       <path
          d="m 63.393719,191.02604 17.794726,-0.63553"
          opacity="1"/>
     </g>
     <g id="handi-seat">
       <g transform="scale(0.45 0.45) translate(130,120) rotate(180) " >
         <use href="#seat" fill="white"/>
       </g>
       <g transform="scale(0.4 0.4) translate(30 10)"><use href="#handi"/></g>
     </g>
          
        </defs>
        <g transform="translate(-860 0)">
          <ZoneB onDone={this.props.hideZones}
                 onSeatClick={this.props.onSeatClick}
                 onMouseSeatEnter={this.props.onMouseSeatEnter}
                 onMouseSeatLeave={this.props.onMouseSeatLeave}
                 onHandiSeatClick={this.props.onHandiSeatClick}
                 SEP={this.props.SEP}
                 seatColour={this.props.seatColour}/>
        </g>
      </svg> 
    </div>);
  }
}

const ZoneCPanel = class ZoneCPanel extends Component {
  render() {
    return (
    <div style={{ width: this.props.width }}>
      <svg viewBox="0 0 1150 1120">
        <defs>
          {getSeatSymbol()}
        </defs>
        <g transform="translate(-1830 -260)">
          <ZoneC onDone={this.props.hideZones}
                 onSeatClick={this.props.onSeatClick}
                 onMouseSeatEnter={this.props.onMouseSeatEnter}
                 onMouseSeatLeave={this.props.onMouseSeatLeave}
                 SEP={this.props.SEP}
                 seatColour={this.props.seatColour}/>
        </g>
      </svg> 
    </div>);
  }
}

const ZoneDPanel = class ZoneDPanel extends Component {
  render() {
    return (
    <div style={{ width: this.props.width }}>
      <svg viewBox="0 0 1125  410">
        <defs>
          {getSeatSymbol()}
        </defs>
        <g transform="translate(-835 -1050)">
          <ZoneD onDone={this.props.hideZones}
                 onSeatClick={this.props.onSeatClick}
                 onMouseSeatEnter={this.props.onMouseSeatEnter}
                 onMouseSeatLeave={this.props.onMouseSeatLeave}
                 SEP={this.props.SEP}
                 seatColour={this.props.seatColour}/>
        </g>
      </svg> 
    </div>);
  }
}

const ZoneA = class ZoneA extends Component {
  getSeatComponent(groupName, seatName) {
    let seatId = groupName+this.props.SEP+seatName;
    return (
      <Seat groupName={groupName}
            seatName={seatName}
            seatColour={this.props.seatColour[seatId]}
            onClick={this.props.onSeatClick}
            onMouseSeatEnter={this.props.onMouseSeatEnter}
            onMouseSeatLeave={this.props.onMouseSeatLeave}
      />
    );
  }
  render() {
    let seatColour = this.props.seatColour;
    return (
    <g>
  <g transform="translate(650 1200) rotate(-60)"><text x="0" y="0" fontSize="600" fill="lightgray">A</text></g>
  <g transform="translate(869 1375) rotate(-79)">{this.getSeatComponent("A", "1", seatColour)}</g>
  <g transform="translate(885 1313) rotate(-73)">{this.getSeatComponent("A", "2", seatColour)}</g>
  <g transform="translate(906 1254) rotate(-67)">{this.getSeatComponent("A", "3", seatColour)}</g>
  <g transform="translate(933 1197) rotate(-62)">{this.getSeatComponent("A", "4", seatColour)}</g>
  <g transform="translate(965 1143) rotate(-56)">{this.getSeatComponent("A", "5", seatColour)}</g>
  <g transform="translate(1003 1092) rotate(-51)">{this.getSeatComponent("A", "6", seatColour)}</g>
  <g transform="translate(1045 1045) rotate(-45)">{this.getSeatComponent("A", "7", seatColour)}</g>
  <g transform="translate(1092 1003) rotate(-39)">{this.getSeatComponent("A", "8", seatColour)}</g>
  <g transform="translate(784 1358) rotate(-79)">{this.getSeatComponent("A", "17", seatColour)}</g>
  <g transform="translate(799 1296) rotate(-74)">{this.getSeatComponent("A", "16", seatColour)}</g>
  <g transform="translate(820 1235) rotate(-69)">{this.getSeatComponent("A", "15", seatColour)}</g>
  <g transform="translate(845 1177) rotate(-64)">{this.getSeatComponent("A", "14", seatColour)}</g>
  <g transform="translate(876 1121) rotate(-59)">{this.getSeatComponent("A", "13", seatColour)}</g>
  <g transform="translate(911 1068) rotate(-54)">{this.getSeatComponent("A", "12", seatColour)}</g>
  <g transform="translate(951 1019) rotate(-49)">{this.getSeatComponent("A", "11", seatColour)}</g>
  <g transform="translate(995 973) rotate(-44)">{this.getSeatComponent("A", "10", seatColour)}</g>
  <g transform="translate(1043 931) rotate(-39)">{this.getSeatComponent("A", "9", seatColour)}</g>
  <g transform="translate(696 1340) rotate(-79)">{this.getSeatComponent("A", "18", seatColour)}</g>
  <g transform="translate(711 1277) rotate(-74)">{this.getSeatComponent("A", "19", seatColour)}</g>
  <g transform="translate(731 1216) rotate(-70)">{this.getSeatComponent("A", "20", seatColour)}</g>
  <g transform="translate(755 1157) rotate(-65)">{this.getSeatComponent("A", "21", seatColour)}</g>
  <g transform="translate(785 1099) rotate(-61)">{this.getSeatComponent("A", "22", seatColour)}</g>
  <g transform="translate(818 1044) rotate(-56)">{this.getSeatComponent("A", "23", seatColour)}</g>
  <g transform="translate(856 992) rotate(-52)">{this.getSeatComponent("A", "24", seatColour)}</g>
  <g transform="translate(898 943) rotate(-47)">{this.getSeatComponent("A", "25", seatColour)}</g>
  <g transform="translate(943 898) rotate(-43)">{this.getSeatComponent("A", "26", seatColour)}</g>
  <g transform="translate(992 856) rotate(-38)">{this.getSeatComponent("A", "27", seatColour)}</g>
  <g transform="translate(603 1321) rotate(-79)">{this.getSeatComponent("A", "38", seatColour)}</g>
  <g transform="translate(618 1258) rotate(-75)">{this.getSeatComponent("A", "37", seatColour)}</g>
  <g transform="translate(637 1196) rotate(-71)">{this.getSeatComponent("A", "36", seatColour)}</g>
  <g transform="translate(661 1135) rotate(-66)">{this.getSeatComponent("A", "35", seatColour)}</g>
  <g transform="translate(689 1076) rotate(-62)">{this.getSeatComponent("A", "34", seatColour)}</g>
  <g transform="translate(722 1019) rotate(-58)">{this.getSeatComponent("A", "33", seatColour)}</g>
  <g transform="translate(758 965) rotate(-54)">{this.getSeatComponent("A", "32", seatColour)}</g>
  <g transform="translate(798 913) rotate(-50)">{this.getSeatComponent("A", "31", seatColour)}</g>
  <g transform="translate(842 865) rotate(-46)">{this.getSeatComponent("A", "30", seatColour)}</g>
  <g transform="translate(889 819) rotate(-42)">{this.getSeatComponent("A", "29", seatColour)}</g>
  <g transform="translate(939 777) rotate(-38)">{this.getSeatComponent("A", "28", seatColour)}</g>
  <g transform="translate(509 1303) rotate(-79)">{this.getSeatComponent("A", "39", seatColour)}</g>
  <g transform="translate(524 1239) rotate(-75)">{this.getSeatComponent("A", "40", seatColour)}</g>
  <g transform="translate(544 1175) rotate(-71)">{this.getSeatComponent("A", "41", seatColour)}</g>
  <g transform="translate(567 1113) rotate(-68)">{this.getSeatComponent("A", "42", seatColour)}</g>
  <g transform="translate(594 1053) rotate(-64)">{this.getSeatComponent("A", "43", seatColour)}</g>
  <g transform="translate(625 995) rotate(-60)">{this.getSeatComponent("A", "44", seatColour)}</g>
  <g transform="translate(660 939) rotate(-56)">{this.getSeatComponent("A", "45", seatColour)}</g>
  <g transform="translate(699 885) rotate(-53)">{this.getSeatComponent("A", "46", seatColour)}</g>
  <g transform="translate(741 834) rotate(-49)">{this.getSeatComponent("A", "47", seatColour)}</g>
  <g transform="translate(786 786) rotate(-45)">{this.getSeatComponent("A", "48", seatColour)}</g>
  <g transform="translate(834 741) rotate(-41)">{this.getSeatComponent("A", "49", seatColour)}</g>
  <g transform="translate(885 699) rotate(-38)">{this.getSeatComponent("A", "50", seatColour)}</g>
  <g transform="translate(411 1283) rotate(-79)">{this.getSeatComponent("A", "64", seatColour)}</g>
  <g transform="translate(425 1223) rotate(-76)">{this.getSeatComponent("A", "63", seatColour)}</g>
  <g transform="translate(442 1163) rotate(-72)">{this.getSeatComponent("A", "62", seatColour)}</g>
  <g transform="translate(463 1104) rotate(-69)">{this.getSeatComponent("A", "61", seatColour)}</g>
  <g transform="translate(487 1047) rotate(-66)">{this.getSeatComponent("A", "60", seatColour)}</g>
  <g transform="translate(514 991) rotate(-63)">{this.getSeatComponent("A", "59", seatColour)}</g>
  <g transform="translate(544 936) rotate(-59)">{this.getSeatComponent("A", "58", seatColour)}</g>
  <g transform="translate(577 883) rotate(-56)">{this.getSeatComponent("A", "57", seatColour)}</g>
  <g transform="translate(613 833) rotate(-53)">{this.getSeatComponent("A", "56", seatColour)}</g>
  <g transform="translate(652 784) rotate(-50)">{this.getSeatComponent("A", "55", seatColour)}</g>
  <g transform="translate(693 737) rotate(-47)">{this.getSeatComponent("A", "54", seatColour)}</g>
  <g transform="translate(737 693) rotate(-43)">{this.getSeatComponent("A", "53", seatColour)}</g>
  <g transform="translate(784 652) rotate(-40)">{this.getSeatComponent("A", "52", seatColour)}</g>
  <g transform="translate(833 613) rotate(-37)">{this.getSeatComponent("A", "51", seatColour)}</g>
  <g transform="translate(313 1264) rotate(-79)">{this.getSeatComponent("A", "65", seatColour)}</g>
  <g transform="translate(326 1206) rotate(-76)">{this.getSeatComponent("A", "66", seatColour)}</g>
  <g transform="translate(342 1149) rotate(-73)">{this.getSeatComponent("A", "67", seatColour)}</g>
  <g transform="translate(361 1092) rotate(-70)">{this.getSeatComponent("A", "68", seatColour)}</g>
  <g transform="translate(382 1037) rotate(-67)">{this.getSeatComponent("A", "69", seatColour)}</g>
  <g transform="translate(406 983) rotate(-65)">{this.getSeatComponent("A", "70", seatColour)}</g>
  <g transform="translate(433 930) rotate(-62)">{this.getSeatComponent("A", "71", seatColour)}</g>
  <g transform="translate(462 878) rotate(-59)">{this.getSeatComponent("A", "72", seatColour)}</g>
  <g transform="translate(494 828) rotate(-56)">{this.getSeatComponent("A", "73", seatColour)}</g>
  <g transform="translate(528 779) rotate(-53)">{this.getSeatComponent("A", "74", seatColour)}</g>
  <g transform="translate(565 732) rotate(-51)">{this.getSeatComponent("A", "75", seatColour)}</g>
  <g transform="translate(603 687) rotate(-48)">{this.getSeatComponent("A", "76", seatColour)}</g>
  <g transform="translate(644 644) rotate(-45)">{this.getSeatComponent("A", "77", seatColour)}</g>
  <g transform="translate(687 603) rotate(-42)">{this.getSeatComponent("A", "78", seatColour)}</g>
  <g transform="translate(732 565) rotate(-39)">{this.getSeatComponent("A", "79", seatColour)}</g>
  <g transform="translate(779 528) rotate(-37)">{this.getSeatComponent("A", "80", seatColour)}</g>
  <g transform="translate(225 1246) rotate(-79)">{this.getSeatComponent("A", "97", seatColour)}</g>
  <g transform="translate(238 1188) rotate(-76)">{this.getSeatComponent("A", "96", seatColour)}</g>
  <g transform="translate(254 1130) rotate(-73)">{this.getSeatComponent("A", "95", seatColour)}</g>
  <g transform="translate(272 1073) rotate(-71)">{this.getSeatComponent("A", "94", seatColour)}</g>
  <g transform="translate(293 1016) rotate(-68)">{this.getSeatComponent("A", "93", seatColour)}</g>
  <g transform="translate(317 961) rotate(-66)">{this.getSeatComponent("A", "92", seatColour)}</g>
  <g transform="translate(343 907) rotate(-63)">{this.getSeatComponent("A", "91", seatColour)}</g>
  <g transform="translate(372 854) rotate(-60)">{this.getSeatComponent("A", "90", seatColour)}</g>
  <g transform="translate(403 803) rotate(-58)">{this.getSeatComponent("A", "89", seatColour)}</g>
  <g transform="translate(436 753) rotate(-55)">{this.getSeatComponent("A", "88", seatColour)}</g>
  <g transform="translate(472 705) rotate(-52)">{this.getSeatComponent("A", "87", seatColour)}</g>
  <g transform="translate(510 658) rotate(-50)">{this.getSeatComponent("A", "86", seatColour)}</g>
  <g transform="translate(549 613) rotate(-47)">{this.getSeatComponent("A", "85", seatColour)}</g>
  <g transform="translate(591 570) rotate(-44)">{this.getSeatComponent("A", "84", seatColour)}</g>
  <g transform="translate(635 529) rotate(-42)">{this.getSeatComponent("A", "83", seatColour)}</g>
  <g transform="translate(681 490) rotate(-39)">{this.getSeatComponent("A", "82", seatColour)}</g>
  <g transform="translate(729 454) rotate(-36)">{this.getSeatComponent("A", "81", seatColour)}</g>
  <g transform="translate(127 1227) rotate(-79)">{this.getSeatComponent("A", "98", seatColour)}</g>
  <g transform="translate(140 1167) rotate(-76)">{this.getSeatComponent("A", "99", seatColour)}</g>
  <g transform="translate(156 1108) rotate(-74)">{this.getSeatComponent("A", "100", seatColour)}</g>
  <g transform="translate(174 1050) rotate(-71)">{this.getSeatComponent("A", "101", seatColour)}</g>
  <g transform="translate(195 993) rotate(-69)">{this.getSeatComponent("A", "102", seatColour)}</g>
  <g transform="translate(219 936) rotate(-66)">{this.getSeatComponent("A", "103", seatColour)}</g>
  <g transform="translate(244 881) rotate(-64)">{this.getSeatComponent("A", "104", seatColour)}</g>
  <g transform="translate(273 827) rotate(-61)">{this.getSeatComponent("A", "105", seatColour)}</g>
  <g transform="translate(303 774) rotate(-59)">{this.getSeatComponent("A", "106", seatColour)}</g>
  <g transform="translate(336 722) rotate(-56)">{this.getSeatComponent("A", "107", seatColour)}</g>
  <g transform="translate(371 672) rotate(-54)">{this.getSeatComponent("A", "108", seatColour)}</g>
  <g transform="translate(408 624) rotate(-51)">{this.getSeatComponent("A", "109", seatColour)}</g>
  <g transform="translate(447 577) rotate(-49)">{this.getSeatComponent("A", "110", seatColour)}</g>
  <g transform="translate(489 532) rotate(-46)">{this.getSeatComponent("A", "111", seatColour)}</g>
  <g transform="translate(532 489) rotate(-44)">{this.getSeatComponent("A", "112", seatColour)}</g>
  <g transform="translate(577 447) rotate(-41)">{this.getSeatComponent("A", "113", seatColour)}</g>
  <g transform="translate(624 408) rotate(-39)">{this.getSeatComponent("A", "114", seatColour)}</g>
  <g transform="translate(672 371) rotate(-36)">{this.getSeatComponent("A", "115", seatColour)}</g>
  <g transform="translate(39 1209) rotate(-79)">{this.getSeatComponent("A", "134", seatColour)}</g>
  <g transform="translate(52 1149) rotate(-76)">{this.getSeatComponent("A", "133", seatColour)}</g>
  <g transform="translate(68 1090) rotate(-74)">{this.getSeatComponent("A", "132", seatColour)}</g>
  <g transform="translate(86 1031) rotate(-72)">{this.getSeatComponent("A", "131", seatColour)}</g>
  <g transform="translate(106 973) rotate(-69)">{this.getSeatComponent("A", "130", seatColour)}</g>
  <g transform="translate(129 916) rotate(-67)">{this.getSeatComponent("A", "129", seatColour)}</g>
  <g transform="translate(155 859) rotate(-65)">{this.getSeatComponent("A", "128", seatColour)}</g>
  <g transform="translate(182 804) rotate(-62)">{this.getSeatComponent("A", "127", seatColour)}</g>
  <g transform="translate(212 751) rotate(-60)">{this.getSeatComponent("A", "126", seatColour)}</g>
  <g transform="translate(244 698) rotate(-57)">{this.getSeatComponent("A", "125", seatColour)}</g>
  <g transform="translate(278 647) rotate(-55)">{this.getSeatComponent("A", "124", seatColour)}</g>
  <g transform="translate(315 597) rotate(-53)">{this.getSeatComponent("A", "123", seatColour)}</g>
  <g transform="translate(353 549) rotate(-50)">{this.getSeatComponent("A", "122", seatColour)}</g>
  <g transform="translate(393 502) rotate(-48)">{this.getSeatComponent("A", "121", seatColour)}</g>
  <g transform="translate(436 457) rotate(-46)">{this.getSeatComponent("A", "120", seatColour)}</g>
  <g transform="translate(480 414) rotate(-43)">{this.getSeatComponent("A", "119", seatColour)}</g>
  <g transform="translate(525 373) rotate(-41)">{this.getSeatComponent("A", "118", seatColour)}</g>
  <g transform="translate(573 334) rotate(-38)">{this.getSeatComponent("A", "117", seatColour)}</g>
  <g transform="translate(622 296) rotate(-36)">{this.getSeatComponent("A", "116", seatColour)}</g>
 
    </g>
        );
  }
}

const ZoneB = class ZoneB extends Component {
  getSeatComponent(groupName, seatName) {
    let seatId = groupName+this.props.SEP+seatName;
    return (
      <Seat groupName={groupName}
            seatName={seatName}
            seatColour={this.props.seatColour[seatId]}
            onClick={this.props.onSeatClick}
            onMouseSeatEnter={this.props.onMouseSeatEnter}
            onMouseSeatLeave={this.props.onMouseSeatLeave}
      />
    );
  }

  getHandiSeatComponent(id) {
    return (<use href="#handi-seat" id={id} onClick={this.props.onHandiSeatClick}/>);
  }

  render() {
    let seatColour = this.props.seatColour;
    return (
    <g>
  <text x="1300" y="600" fontSize="600" fill="lightgray">B</text>
  <g transform="translate(1242 911) rotate(-24)">{this.getSeatComponent("B", "1", seatColour)}</g>
  <g transform="translate(1297 890) rotate(-18)">{this.getSeatComponent("B", "2", seatColour)}</g>
  <g transform="translate(1354 874) rotate(-13)">{this.getSeatComponent("B", "3", seatColour)}</g>
  <g transform="translate(1412 863) rotate(-8)">{this.getSeatComponent("B", "4", seatColour)}</g>
  <g transform="translate(1470 858) rotate(-3)">{this.getSeatComponent("B", "5", seatColour)}</g>
  <g transform="translate(1530 858) rotate(3)">{this.getSeatComponent("B", "6", seatColour)}</g>
  <g transform="translate(1588 863) rotate(8)">{this.getSeatComponent("B", "7", seatColour)}</g>
  <g transform="translate(1646 874) rotate(13)">{this.getSeatComponent("B", "8", seatColour)}</g>
  <g transform="translate(1703 890) rotate(18)">{this.getSeatComponent("B", "9", seatColour)}</g>
  <g transform="translate(1207 831) rotate(-24)">{this.getSeatComponent("B", "19", seatColour)}</g>
  <g transform="translate(1263 810) rotate(-19)">{this.getSeatComponent("B", "18", seatColour)}</g>
  <g transform="translate(1321 792) rotate(-14)">{this.getSeatComponent("B", "17", seatColour)}</g>
  <g transform="translate(1380 780) rotate(-9)">{this.getSeatComponent("B", "16", seatColour)}</g>
  <g transform="translate(1440 772) rotate(-5)">{this.getSeatComponent("B", "15", seatColour)}</g>
  <g transform="translate(1500 770) rotate(0)">{this.getSeatComponent("B", "14", seatColour)}</g>
  <g transform="translate(1560 772) rotate(5)">{this.getSeatComponent("B", "13", seatColour)}</g>
  <g transform="translate(1620 780) rotate(9)">{this.getSeatComponent("B", "12", seatColour)}</g>
  <g transform="translate(1679 792) rotate(14)">{this.getSeatComponent("B", "11", seatColour)}</g>
  <g transform="translate(1737 810) rotate(19)">{this.getSeatComponent("B", "10", seatColour)}</g>
  <g transform="translate(1171 749) rotate(-24)">{this.getSeatComponent("B", "20", seatColour)}</g>
  <g transform="translate(1228 726) rotate(-19)">{this.getSeatComponent("B", "21", seatColour)}</g>
  <g transform="translate(1287 708) rotate(-15)">{this.getSeatComponent("B", "22", seatColour)}</g>
  <g transform="translate(1347 694) rotate(-11)">{this.getSeatComponent("B", "23", seatColour)}</g>
  <g transform="translate(1408 685) rotate(-6)">{this.getSeatComponent("B", "24", seatColour)}</g>
  <g transform="translate(1469 681) rotate(-2)">{this.getSeatComponent("B", "25", seatColour)}</g>
  <g transform="translate(1531 681) rotate(2)">{this.getSeatComponent("B", "26", seatColour)}</g>
  <g transform="translate(1592 685) rotate(6)">{this.getSeatComponent("B", "27", seatColour)}</g>
  <g transform="translate(1653 694) rotate(11)">{this.getSeatComponent("B", "28", seatColour)}</g>
  <g transform="translate(1713 708) rotate(15)">{this.getSeatComponent("B", "29", seatColour)}</g>
  <g transform="translate(1772 726) rotate(19)">{this.getSeatComponent("B", "30", seatColour)}</g>
  <g transform="translate(1132 662) rotate(-24)">{this.getSeatComponent("B", "43", seatColour)}</g>
  <g transform="translate(1186 640) rotate(-20)">{this.getSeatComponent("B", "42", seatColour)}</g>
  <g transform="translate(1242 622) rotate(-16)">{this.getSeatComponent("B", "41", seatColour)}</g>
  <g transform="translate(1298 608) rotate(-13)">{this.getSeatComponent("B", "40", seatColour)}</g>
  <g transform="translate(1355 597) rotate(-9)">{this.getSeatComponent("B", "39", seatColour)}</g>
  <g transform="translate(1413 589) rotate(-5)">{this.getSeatComponent("B", "38", seatColour)}</g>
  <g transform="translate(1471 585) rotate(-2)">{this.getSeatComponent("B", "37", seatColour)}</g>
  <g transform="translate(1529 585) rotate(2)">{this.getSeatComponent("B", "36", seatColour)}</g>
  <g transform="translate(1587 589) rotate(5)">{this.getSeatComponent("B", "35", seatColour)}</g>
  <g transform="translate(1645 597) rotate(9)">{this.getSeatComponent("B", "34", seatColour)}</g>
  <g transform="translate(1702 608) rotate(13)">{this.getSeatComponent("B", "33", seatColour)}</g>
  <g transform="translate(1758 622) rotate(16)">{this.getSeatComponent("B", "32", seatColour)}</g>
  <g transform="translate(1814 640) rotate(20)">{this.getSeatComponent("B", "31", seatColour)}</g>
  <g transform="translate(1094 575) rotate(-24)">{this.getSeatComponent("B", "44", seatColour)}</g>
  <g transform="translate(1150 553) rotate(-20)">{this.getSeatComponent("B", "45", seatColour)}</g>
  <g transform="translate(1206 534) rotate(-17)">{this.getSeatComponent("B", "46", seatColour)}</g>
  <g transform="translate(1264 518) rotate(-14)">{this.getSeatComponent("B", "47", seatColour)}</g>
  <g transform="translate(1322 506) rotate(-10)">{this.getSeatComponent("B", "48", seatColour)}</g>
  <g transform="translate(1381 497) rotate(-7)">{this.getSeatComponent("B", "49", seatColour)}</g>
  <g transform="translate(1440 492) rotate(-3)">{this.getSeatComponent("B", "50", seatColour)}</g>
  <g transform="translate(1500 490) rotate(0)">{this.getSeatComponent("B", "51", seatColour)}</g>
  <g transform="translate(1560 492) rotate(3)">{this.getSeatComponent("B", "52", seatColour)}</g>
  <g transform="translate(1619 497) rotate(7)">{this.getSeatComponent("B", "53", seatColour)}</g>
  <g transform="translate(1678 506) rotate(10)">{this.getSeatComponent("B", "54", seatColour)}</g>
  <g transform="translate(1736 518) rotate(14)">{this.getSeatComponent("B", "55", seatColour)}</g>
  <g transform="translate(1794 534) rotate(17)">{this.getSeatComponent("B", "56", seatColour)}</g>
  <g transform="translate(1850 553) rotate(20)">{this.getSeatComponent("B", "57", seatColour)}</g>
  <g transform="translate(1054 483) rotate(-24)">{this.getSeatComponent("B", "72", seatColour)}</g>
  <g transform="translate(1111 460) rotate(-21)">{this.getSeatComponent("B", "71", seatColour)}</g>
  <g transform="translate(1169 441) rotate(-17)">{this.getSeatComponent("B", "70", seatColour)}</g>
  <g transform="translate(1228 424) rotate(-14)">{this.getSeatComponent("B", "69", seatColour)}</g>
  <g transform="translate(1287 411) rotate(-11)">{this.getSeatComponent("B", "68", seatColour)}</g>
  <g transform="translate(1348 401) rotate(-8)">{this.getSeatComponent("B", "67", seatColour)}</g>
  <g transform="translate(1408 394) rotate(-5)">{this.getSeatComponent("B", "66", seatColour)}</g>
  <g transform="translate(1469 390) rotate(-2)">{this.getSeatComponent("B", "65", seatColour)}</g>
  <g transform="translate(1531 390) rotate(2)">{this.getSeatComponent("B", "64", seatColour)}</g>
  <g transform="translate(1592 394) rotate(5)">{this.getSeatComponent("B", "63", seatColour)}</g>
  <g transform="translate(1652 401) rotate(8)">{this.getSeatComponent("B", "62", seatColour)}</g>
  <g transform="translate(1713 411) rotate(11)">{this.getSeatComponent("B", "61", seatColour)}</g>
  <g transform="translate(1772 424) rotate(14)">{this.getSeatComponent("B", "60", seatColour)}</g>
  <g transform="translate(1831 441) rotate(17)">{this.getSeatComponent("B", "59", seatColour)}</g>
  <g transform="translate(1889 460) rotate(21)">{this.getSeatComponent("B", "58", seatColour)}</g>
  <g transform="translate(1014 392) rotate(-24)">{this.getSeatComponent("B", "73", seatColour)}</g>
  <g transform="translate(1068 370) rotate(-21)">{this.getSeatComponent("B", "74", seatColour)}</g>
  <g transform="translate(1124 350) rotate(-18)">{this.getSeatComponent("B", "75", seatColour)}</g>
  <g transform="translate(1180 333) rotate(-15)">{this.getSeatComponent("B", "76", seatColour)}</g>
  <g transform="translate(1237 319) rotate(-13)">{this.getSeatComponent("B", "77", seatColour)}</g>
  <g transform="translate(1295 307) rotate(-10)">{this.getSeatComponent("B", "78", seatColour)}</g>
  <g transform="translate(1353 299) rotate(-7)">{this.getSeatComponent("B", "79", seatColour)}</g>
  <g transform="translate(1412 293) rotate(-4)">{this.getSeatComponent("B", "80", seatColour)}</g>
  <g transform="translate(1471 290) rotate(-1)">{this.getSeatComponent("B", "81", seatColour)}</g>
  <g transform="translate(1529 290) rotate(1)">{this.getSeatComponent("B", "82", seatColour)}</g>
  <g transform="translate(1588 293) rotate(4)">{this.getSeatComponent("B", "83", seatColour)}</g>
  <g transform="translate(1647 299) rotate(7)">{this.getSeatComponent("B", "84", seatColour)}</g>
  <g transform="translate(1705 307) rotate(10)">{this.getSeatComponent("B", "85", seatColour)}</g>
  <g transform="translate(1763 319) rotate(13)">{this.getSeatComponent("B", "86", seatColour)}</g>
  <g transform="translate(1820 333) rotate(15)">{this.getSeatComponent("B", "87", seatColour)}</g>
  <g transform="translate(1876 350) rotate(18)">{this.getSeatComponent("B", "88", seatColour)}</g>
  <g transform="translate(1932 370) rotate(21)">{this.getSeatComponent("B", "89", seatColour)}</g>
  <g transform="translate(978 309) rotate(-24)">{this.getSeatComponent("B", "108", seatColour)}</g>
  <g transform="translate(1030 288) rotate(-21)">{this.getSeatComponent("B", "107", seatColour)}</g>
  <g transform="translate(1083 269) rotate(-19)">{this.getSeatComponent("B", "106", seatColour)}</g>
  <g transform="translate(1137 252) rotate(-16)">{this.getSeatComponent("B", "105", seatColour)}</g>
  <g transform="translate(1192 237) rotate(-14)">{this.getSeatComponent("B", "104", seatColour)}</g>
  <g transform="translate(1247 225) rotate(-11)">{this.getSeatComponent("B", "103", seatColour)}</g>
  <g transform="translate(1303 215) rotate(-9)">{this.getSeatComponent("B", "102", seatColour)}</g>
  <g transform="translate(1359 208) rotate(-6)">{this.getSeatComponent("B", "101", seatColour)}</g>
  <g transform="translate(1415 203) rotate(-4)">{this.getSeatComponent("B", "100", seatColour)}</g>
  <g transform="translate(1472 200) rotate(-1)">{this.getSeatComponent("B", "99", seatColour)}</g>
  <g transform="translate(1528 200) rotate(1)">{this.getSeatComponent("B", "98", seatColour)}</g>
  <g transform="translate(1585 203) rotate(4)">{this.getSeatComponent("B", "97", seatColour)}</g>
  <g transform="translate(1641 208) rotate(6)">{this.getSeatComponent("B", "96", seatColour)}</g>
  <g transform="translate(1697 215) rotate(9)">{this.getSeatComponent("B", "95", seatColour)}</g>
  <g transform="translate(1753 225) rotate(11)">{this.getSeatComponent("B", "94", seatColour)}</g>
  <g transform="translate(1808 237) rotate(14)">{this.getSeatComponent("B", "93", seatColour)}</g>
  <g transform="translate(1863 252) rotate(16)">{this.getSeatComponent("B", "92", seatColour)}</g>
  <g transform="translate(1917 269) rotate(19)">{this.getSeatComponent("B", "91", seatColour)}</g>
  <g transform="translate(1970 288) rotate(21)">{this.getSeatComponent("B", "90", seatColour)}</g>
  <g transform="translate(938 218) rotate(-24)">{this.getSeatComponent("B", "109", seatColour)}</g>
  <g transform="translate(994 195) rotate(-21)">{this.getSeatComponent("B", "110", seatColour)}</g>
  <g transform="translate(1051 174) rotate(-19)">{this.getSeatComponent("B", "111", seatColour)}</g>
  <g transform="translate(1109 156) rotate(-16)">{this.getSeatComponent("B", "112", seatColour)}</g>
  <g transform="translate(1168 140) rotate(-14)">{this.getSeatComponent("B", "113", seatColour)}</g>
  <g transform="translate(1228 127) rotate(-11)">{this.getSeatComponent("B", "114", seatColour)}</g>
  <g transform="translate(1288 116) rotate(-9)">{this.getSeatComponent("B", "115", seatColour)}</g>
  <g transform="translate(1348 108) rotate(-6)">{this.getSeatComponent("B", "116", seatColour)}</g>
  <g transform="translate(1409 103) rotate(-4)">{this.getSeatComponent("B", "117", seatColour)}</g>
  <g transform="translate(1470 100) rotate(-1)">{this.getSeatComponent("B", "118", seatColour)}</g>
  <g transform="translate(1530 100) rotate(1)">{this.getSeatComponent("B", "119", seatColour)}</g>
  <g transform="translate(1591 103) rotate(4)">{this.getSeatComponent("B", "120", seatColour)}</g>
  <g transform="translate(1652 108) rotate(6)">{this.getSeatComponent("B", "121", seatColour)}</g>
  <g transform="translate(1712 116) rotate(9)">{this.getSeatComponent("B", "122", seatColour)}</g>
  <g transform="translate(1772 127) rotate(11)">{this.getSeatComponent("B", "123", seatColour)}</g>
  <g transform="translate(1832 140) rotate(14)">{this.getSeatComponent("B", "124", seatColour)}</g>
  <g transform="translate(1891 156) rotate(16)">{this.getSeatComponent("B", "125", seatColour)}</g>
  <g transform="translate(1949 174) rotate(19)">{this.getSeatComponent("B", "126", seatColour)}</g>
  <g transform="translate(2006 195) rotate(21)">{this.getSeatComponent("B", "127", seatColour)}</g>
  <g transform="translate(901 135) rotate(-24)">{this.getHandiSeatComponent()}</g>
  <g transform="translate(956 113) rotate(-21)">{this.getHandiSeatComponent()}</g>
  <g transform="translate(1011 93) rotate(-19)">{this.getHandiSeatComponent()}</g>
  <g transform="translate(1066 74) rotate(-17)">{this.getSeatComponent("B", "145", seatColour)}</g>
  <g transform="translate(1123 59) rotate(-15)">{this.getSeatComponent("B", "144", seatColour)}</g>
  <g transform="translate(1180 45) rotate(-12)">{this.getSeatComponent("B", "143", seatColour)}</g>
  <g transform="translate(1237 33) rotate(-10)">{this.getSeatComponent("B", "142", seatColour)}</g>
  <g transform="translate(1295 24) rotate(-8)">{this.getSeatComponent("B", "141", seatColour)}</g>
  <g transform="translate(1354 17) rotate(-6)">{this.getSeatComponent("B", "140", seatColour)}</g>
  <g transform="translate(1412 13) rotate(-3)">{this.getSeatComponent("B", "139", seatColour)}</g>
  <g transform="translate(1471 10) rotate(-1)">{this.getSeatComponent("B", "138", seatColour)}</g>
  <g transform="translate(1529 10) rotate(1)">{this.getSeatComponent("B", "137", seatColour)}</g>
  <g transform="translate(1588 13) rotate(3)">{this.getSeatComponent("B", "136", seatColour)}</g>
  <g transform="translate(1646 17) rotate(6)">{this.getSeatComponent("B", "135", seatColour)}</g>
  <g transform="translate(1705 24) rotate(8)">{this.getSeatComponent("B", "134", seatColour)}</g>
  <g transform="translate(1763 33) rotate(10)">{this.getSeatComponent("B", "133", seatColour)}</g>
  <g transform="translate(1820 45) rotate(12)">{this.getSeatComponent("B", "132", seatColour)}</g>
  <g transform="translate(1877 59) rotate(15)">{this.getSeatComponent("B", "131", seatColour)}</g>
  <g transform="translate(1934 74) rotate(17)">{this.getHandiSeatComponent()}</g>
  <g transform="translate(1989 93) rotate(19)">{this.getHandiSeatComponent()}</g>
  <g transform="translate(2044 113) rotate(21)">{this.getHandiSeatComponent()}</g>
</g>
        );
  }
}

const ZoneC = class ZoneC extends Component {
  getSeatComponent(groupName, seatName) {
    let seatId = groupName+this.props.SEP+seatName;
    return (
      <Seat groupName={groupName}
            seatName={seatName}
            seatColour={this.props.seatColour[seatId]}
            onClick={this.props.onSeatClick}
            onMouseSeatEnter={this.props.onMouseSeatEnter}
            onMouseSeatLeave={this.props.onMouseSeatLeave}
      />
    );
  }
  render() {
    let seatColour = this.props.seatColour;
    return (
    <g>
  <g transform="translate(2100 800) rotate(60)"><text x="0" y="0" fontSize="600" fill="lightgray">C</text></g>
  <g transform="translate(1857 965) rotate(34)">{this.getSeatComponent("C", "1", seatColour)}</g>
  <g transform="translate(1908 1003) rotate(39)">{this.getSeatComponent("C", "2", seatColour)}</g>
  <g transform="translate(1955 1045) rotate(45)">{this.getSeatComponent("C", "3", seatColour)}</g>
  <g transform="translate(1997 1092) rotate(51)">{this.getSeatComponent("C", "4", seatColour)}</g>
  <g transform="translate(2035 1143) rotate(56)">{this.getSeatComponent("C", "5", seatColour)}</g>
  <g transform="translate(2067 1197) rotate(62)">{this.getSeatComponent("C", "6", seatColour)}</g>
  <g transform="translate(2094 1254) rotate(68)">{this.getSeatComponent("C", "7", seatColour)}</g>
  <g transform="translate(2115 1313) rotate(73)">{this.getSeatComponent("C", "8", seatColour)}</g>
  <g transform="translate(1906 893) rotate(34)">{this.getSeatComponent("C", "17", seatColour)}</g>
  <g transform="translate(1957 931) rotate(39)">{this.getSeatComponent("C", "16", seatColour)}</g>
  <g transform="translate(2005 973) rotate(44)">{this.getSeatComponent("C", "15", seatColour)}</g>
  <g transform="translate(2049 1019) rotate(49)">{this.getSeatComponent("C", "14", seatColour)}</g>
  <g transform="translate(2089 1068) rotate(54)">{this.getSeatComponent("C", "13", seatColour)}</g>
  <g transform="translate(2124 1121) rotate(59)">{this.getSeatComponent("C", "12", seatColour)}</g>
  <g transform="translate(2155 1177) rotate(64)">{this.getSeatComponent("C", "11", seatColour)}</g>
  <g transform="translate(2180 1235) rotate(69)">{this.getSeatComponent("C", "10", seatColour)}</g>
  <g transform="translate(2201 1296) rotate(74)">{this.getSeatComponent("C", "9", seatColour)}</g>
  <g transform="translate(1956 818) rotate(34)">{this.getSeatComponent("C", "18", seatColour)}</g>
  <g transform="translate(2008 856) rotate(38)">{this.getSeatComponent("C", "19", seatColour)}</g>
  <g transform="translate(2057 898) rotate(43)">{this.getSeatComponent("C", "20", seatColour)}</g>
  <g transform="translate(2102 943) rotate(47)">{this.getSeatComponent("C", "21", seatColour)}</g>
  <g transform="translate(2144 992) rotate(52)">{this.getSeatComponent("C", "22", seatColour)}</g>
  <g transform="translate(2182 1044) rotate(56)">{this.getSeatComponent("C", "23", seatColour)}</g>
  <g transform="translate(2215 1099) rotate(61)">{this.getSeatComponent("C", "24", seatColour)}</g>
  <g transform="translate(2245 1157) rotate(65)">{this.getSeatComponent("C", "25", seatColour)}</g>
  <g transform="translate(2269 1216) rotate(70)">{this.getSeatComponent("C", "26", seatColour)}</g>
  <g transform="translate(2289 1277) rotate(74)">{this.getSeatComponent("C", "27", seatColour)}</g>
  <g transform="translate(2008 739) rotate(34)">{this.getSeatComponent("C", "38", seatColour)}</g>
  <g transform="translate(2061 777) rotate(38)">{this.getSeatComponent("C", "37", seatColour)}</g>
  <g transform="translate(2111 819) rotate(42)">{this.getSeatComponent("C", "36", seatColour)}</g>
  <g transform="translate(2158 865) rotate(46)">{this.getSeatComponent("C", "35", seatColour)}</g>
  <g transform="translate(2202 913) rotate(50)">{this.getSeatComponent("C", "34", seatColour)}</g>
  <g transform="translate(2242 965) rotate(54)">{this.getSeatComponent("C", "33", seatColour)}</g>
  <g transform="translate(2278 1019) rotate(58)">{this.getSeatComponent("C", "32", seatColour)}</g>
  <g transform="translate(2311 1076) rotate(62)">{this.getSeatComponent("C", "31", seatColour)}</g>
  <g transform="translate(2339 1135) rotate(66)">{this.getSeatComponent("C", "30", seatColour)}</g>
  <g transform="translate(2363 1196) rotate(71)">{this.getSeatComponent("C", "29", seatColour)}</g>
  <g transform="translate(2382 1258) rotate(75)">{this.getSeatComponent("C", "28", seatColour)}</g>
  <g transform="translate(2061 660) rotate(34)">{this.getSeatComponent("C", "39", seatColour)}</g>
  <g transform="translate(2115 699) rotate(38)">{this.getSeatComponent("C", "40", seatColour)}</g>
  <g transform="translate(2166 741) rotate(41)">{this.getSeatComponent("C", "41", seatColour)}</g>
  <g transform="translate(2214 786) rotate(45)">{this.getSeatComponent("C", "42", seatColour)}</g>
  <g transform="translate(2259 834) rotate(49)">{this.getSeatComponent("C", "43", seatColour)}</g>
  <g transform="translate(2301 885) rotate(53)">{this.getSeatComponent("C", "44", seatColour)}</g>
  <g transform="translate(2340 939) rotate(56)">{this.getSeatComponent("C", "45", seatColour)}</g>
  <g transform="translate(2375 995) rotate(60)">{this.getSeatComponent("C", "46", seatColour)}</g>
  <g transform="translate(2406 1053) rotate(64)">{this.getSeatComponent("C", "47", seatColour)}</g>
  <g transform="translate(2433 1113) rotate(68)">{this.getSeatComponent("C", "48", seatColour)}</g>
  <g transform="translate(2456 1175) rotate(71)">{this.getSeatComponent("C", "49", seatColour)}</g>
  <g transform="translate(2476 1239) rotate(75)">{this.getSeatComponent("C", "50", seatColour)}</g>
  <g transform="translate(2117 577) rotate(34)">{this.getSeatComponent("C", "64", seatColour)}</g>
  <g transform="translate(2167 613) rotate(37)">{this.getSeatComponent("C", "63", seatColour)}</g>
  <g transform="translate(2216 652) rotate(40)">{this.getSeatComponent("C", "62", seatColour)}</g>
  <g transform="translate(2263 693) rotate(43)">{this.getSeatComponent("C", "61", seatColour)}</g>
  <g transform="translate(2307 737) rotate(47)">{this.getSeatComponent("C", "60", seatColour)}</g>
  <g transform="translate(2348 784) rotate(50)">{this.getSeatComponent("C", "59", seatColour)}</g>
  <g transform="translate(2387 833) rotate(53)">{this.getSeatComponent("C", "58", seatColour)}</g>
  <g transform="translate(2423 883) rotate(56)">{this.getSeatComponent("C", "57", seatColour)}</g>
  <g transform="translate(2456 936) rotate(59)">{this.getSeatComponent("C", "56", seatColour)}</g>
  <g transform="translate(2486 991) rotate(63)">{this.getSeatComponent("C", "55", seatColour)}</g>
  <g transform="translate(2513 1047) rotate(66)">{this.getSeatComponent("C", "54", seatColour)}</g>
  <g transform="translate(2537 1104) rotate(69)">{this.getSeatComponent("C", "53", seatColour)}</g>
  <g transform="translate(2558 1163) rotate(72)">{this.getSeatComponent("C", "52", seatColour)}</g>
  <g transform="translate(2575 1223) rotate(76)">{this.getSeatComponent("C", "51", seatColour)}</g>
  <g transform="translate(2172 494) rotate(34)">{this.getSeatComponent("C", "65", seatColour)}</g>
  <g transform="translate(2221 528) rotate(37)">{this.getSeatComponent("C", "66", seatColour)}</g>
  <g transform="translate(2268 565) rotate(39)">{this.getSeatComponent("C", "67", seatColour)}</g>
  <g transform="translate(2313 603) rotate(42)">{this.getSeatComponent("C", "68", seatColour)}</g>
  <g transform="translate(2356 644) rotate(45)">{this.getSeatComponent("C", "69", seatColour)}</g>
  <g transform="translate(2397 687) rotate(48)">{this.getSeatComponent("C", "70", seatColour)}</g>
  <g transform="translate(2435 732) rotate(51)">{this.getSeatComponent("C", "71", seatColour)}</g>
  <g transform="translate(2472 779) rotate(53)">{this.getSeatComponent("C", "72", seatColour)}</g>
  <g transform="translate(2506 828) rotate(56)">{this.getSeatComponent("C", "73", seatColour)}</g>
  <g transform="translate(2538 878) rotate(59)">{this.getSeatComponent("C", "74", seatColour)}</g>
  <g transform="translate(2567 930) rotate(62)">{this.getSeatComponent("C", "75", seatColour)}</g>
  <g transform="translate(2594 983) rotate(65)">{this.getSeatComponent("C", "76", seatColour)}</g>
  <g transform="translate(2618 1037) rotate(68)">{this.getSeatComponent("C", "77", seatColour)}</g>
  <g transform="translate(2639 1092) rotate(70)">{this.getSeatComponent("C", "78", seatColour)}</g>
  <g transform="translate(2658 1149) rotate(73)">{this.getSeatComponent("C", "79", seatColour)}</g>
  <g transform="translate(2674 1206) rotate(76)">{this.getSeatComponent("C", "80", seatColour)}</g>
  <g transform="translate(2222 419) rotate(34)">{this.getSeatComponent("C", "97", seatColour)}</g>
  <g transform="translate(2271 454) rotate(36)">{this.getSeatComponent("C", "96", seatColour)}</g>
  <g transform="translate(2319 490) rotate(39)">{this.getSeatComponent("C", "95", seatColour)}</g>
  <g transform="translate(2365 529) rotate(42)">{this.getSeatComponent("C", "94", seatColour)}</g>
  <g transform="translate(2409 570) rotate(44)">{this.getSeatComponent("C", "93", seatColour)}</g>
  <g transform="translate(2451 613) rotate(47)">{this.getSeatComponent("C", "92", seatColour)}</g>
  <g transform="translate(2490 658) rotate(50)">{this.getSeatComponent("C", "91", seatColour)}</g>
  <g transform="translate(2528 705) rotate(52)">{this.getSeatComponent("C", "90", seatColour)}</g>
  <g transform="translate(2564 753) rotate(55)">{this.getSeatComponent("C", "89", seatColour)}</g>
  <g transform="translate(2597 803) rotate(58)">{this.getSeatComponent("C", "88", seatColour)}</g>
  <g transform="translate(2628 854) rotate(60)">{this.getSeatComponent("C", "87", seatColour)}</g>
  <g transform="translate(2657 907) rotate(63)">{this.getSeatComponent("C", "86", seatColour)}</g>
  <g transform="translate(2683 961) rotate(66)">{this.getSeatComponent("C", "85", seatColour)}</g>
  <g transform="translate(2707 1016) rotate(68)">{this.getSeatComponent("C", "84", seatColour)}</g>
  <g transform="translate(2728 1073) rotate(71)">{this.getSeatComponent("C", "83", seatColour)}</g>
  <g transform="translate(2746 1130) rotate(73)">{this.getSeatComponent("C", "82", seatColour)}</g>
  <g transform="translate(2762 1188) rotate(76)">{this.getSeatComponent("C", "81", seatColour)}</g>
  <g transform="translate(2278 336) rotate(34)">{this.getSeatComponent("C", "98", seatColour)}</g>
  <g transform="translate(2328 371) rotate(36)">{this.getSeatComponent("C", "99", seatColour)}</g>
  <g transform="translate(2376 408) rotate(39)">{this.getSeatComponent("C", "100", seatColour)}</g>
  <g transform="translate(2423 447) rotate(41)">{this.getSeatComponent("C", "101", seatColour)}</g>
  <g transform="translate(2468 489) rotate(44)">{this.getSeatComponent("C", "102", seatColour)}</g>
  <g transform="translate(2511 532) rotate(46)">{this.getSeatComponent("C", "103", seatColour)}</g>
  <g transform="translate(2553 577) rotate(49)">{this.getSeatComponent("C", "104", seatColour)}</g>
  <g transform="translate(2592 624) rotate(51)">{this.getSeatComponent("C", "105", seatColour)}</g>
  <g transform="translate(2629 672) rotate(54)">{this.getSeatComponent("C", "106", seatColour)}</g>
  <g transform="translate(2664 722) rotate(56)">{this.getSeatComponent("C", "107", seatColour)}</g>
  <g transform="translate(2697 774) rotate(59)">{this.getSeatComponent("C", "108", seatColour)}</g>
  <g transform="translate(2727 827) rotate(61)">{this.getSeatComponent("C", "109", seatColour)}</g>
  <g transform="translate(2756 881) rotate(64)">{this.getSeatComponent("C", "110", seatColour)}</g>
  <g transform="translate(2781 936) rotate(66)">{this.getSeatComponent("C", "111", seatColour)}</g>
  <g transform="translate(2805 993) rotate(69)">{this.getSeatComponent("C", "112", seatColour)}</g>
  <g transform="translate(2826 1050) rotate(71)">{this.getSeatComponent("C", "113", seatColour)}</g>
  <g transform="translate(2844 1108) rotate(74)">{this.getSeatComponent("C", "114", seatColour)}</g>
  <g transform="translate(2860 1167) rotate(76)">{this.getSeatComponent("C", "115", seatColour)}</g>
  <g transform="translate(2328 261) rotate(34)">{this.getSeatComponent("C", "134", seatColour)}</g>
  <g transform="translate(2378 296) rotate(36)">{this.getSeatComponent("C", "133", seatColour)}</g>
  <g transform="translate(2427 334) rotate(38)">{this.getSeatComponent("C", "132", seatColour)}</g>
  <g transform="translate(2475 373) rotate(41)">{this.getSeatComponent("C", "131", seatColour)}</g>
  <g transform="translate(2520 414) rotate(43)">{this.getSeatComponent("C", "130", seatColour)}</g>
  <g transform="translate(2564 457) rotate(46)">{this.getSeatComponent("C", "129", seatColour)}</g>
  <g transform="translate(2607 502) rotate(48)">{this.getSeatComponent("C", "128", seatColour)}</g>
  <g transform="translate(2647 549) rotate(50)">{this.getSeatComponent("C", "127", seatColour)}</g>
  <g transform="translate(2685 597) rotate(53)">{this.getSeatComponent("C", "126", seatColour)}</g>
  <g transform="translate(2722 647) rotate(55)">{this.getSeatComponent("C", "125", seatColour)}</g>
  <g transform="translate(2756 698) rotate(57)">{this.getSeatComponent("C", "124", seatColour)}</g>
  <g transform="translate(2788 751) rotate(60)">{this.getSeatComponent("C", "123", seatColour)}</g>
  <g transform="translate(2818 804) rotate(62)">{this.getSeatComponent("C", "122", seatColour)}</g>
  <g transform="translate(2845 859) rotate(65)">{this.getSeatComponent("C", "121", seatColour)}</g>
  <g transform="translate(2871 916) rotate(67)">{this.getSeatComponent("C", "120", seatColour)}</g>
  <g transform="translate(2894 973) rotate(69)">{this.getSeatComponent("C", "119", seatColour)}</g>
  <g transform="translate(2914 1031) rotate(72)">{this.getSeatComponent("C", "118", seatColour)}</g>
  <g transform="translate(2932 1090) rotate(74)">{this.getSeatComponent("C", "117", seatColour)}</g>
  <g transform="translate(2948 1149) rotate(76)">{this.getSeatComponent("C", "116", seatColour)}</g>
    </g>);
  }
}

const ZoneD = class ZoneD extends Component {
  getSeatComponent(groupName, seatName) {
    let seatId = groupName+this.props.SEP+seatName;
    return (
      <Seat groupName={groupName}
            seatName={seatName}
            seatColour={this.props.seatColour[seatId]}
            onClick={this.props.onSeatClick}
            onMouseSeatEnter={this.props.onMouseSeatEnter}
            onMouseSeatLeave={this.props.onMouseSeatLeave}
      />
    );
  }
  render() {
    let seatColour = this.props.seatColour;
    return (
    <g>
  <text x="1300" y="1500" fontSize="600" fill="lightgray">D</text>
  <g transform="translate(1035 1410)">{this.getSeatComponent("D", "1", seatColour)}</g>
  <g transform="translate(1093 1410)">{this.getSeatComponent("D", "2", seatColour)}</g>
  <g transform="translate(1151 1410)">{this.getSeatComponent("D", "3", seatColour)}</g>
  <g transform="translate(1209 1410)">{this.getSeatComponent("D", "4", seatColour)}</g>
  <g transform="translate(1267 1410)">{this.getSeatComponent("D", "5", seatColour)}</g>
  <g transform="translate(1325 1410)">{this.getSeatComponent("D", "6", seatColour)}</g>
  <g transform="translate(1383 1410)">{this.getSeatComponent("D", "7", seatColour)}</g>
  <g transform="translate(1441 1410)">{this.getSeatComponent("D", "8", seatColour)}</g>
  <g transform="translate(1499 1410)">{this.getSeatComponent("D", "9", seatColour)}</g>
  <g transform="translate(1557 1410)">{this.getSeatComponent("D", "10", seatColour)}</g>
  <g transform="translate(1615 1410)">{this.getSeatComponent("D", "11", seatColour)}</g>
  <g transform="translate(1673 1410)">{this.getSeatComponent("D", "12", seatColour)}</g>
  <g transform="translate(1731 1410)">{this.getSeatComponent("D", "13", seatColour)}</g>
  <g transform="translate(1789 1410)">{this.getSeatComponent("D", "14", seatColour)}</g>
  <g transform="translate(1847 1410)">{this.getSeatComponent("D", "15", seatColour)}</g>
  <g transform="translate(1905 1410)">{this.getSeatComponent("D", "16", seatColour)}</g>
  <g transform="translate(1873 1320)">{this.getSeatComponent("D", "31", seatColour)}</g>
  <g transform="translate(1816 1320)">{this.getSeatComponent("D", "30", seatColour)}</g>
  <g transform="translate(1759 1320)">{this.getSeatComponent("D", "29", seatColour)}</g>
  <g transform="translate(1702 1320)">{this.getSeatComponent("D", "28", seatColour)}</g>
  <g transform="translate(1645 1320)">{this.getSeatComponent("D", "27", seatColour)}</g>
  <g transform="translate(1588 1320)">{this.getSeatComponent("D", "26", seatColour)}</g>
  <g transform="translate(1531 1320)">{this.getSeatComponent("D", "25", seatColour)}</g>
  <g transform="translate(1474 1320)">{this.getSeatComponent("D", "24", seatColour)}</g>
  <g transform="translate(1417 1320)">{this.getSeatComponent("D", "23", seatColour)}</g>
  <g transform="translate(1360 1320)">{this.getSeatComponent("D", "22", seatColour)}</g>
  <g transform="translate(1303 1320)">{this.getSeatComponent("D", "21", seatColour)}</g>
  <g transform="translate(1246 1320)">{this.getSeatComponent("D", "20", seatColour)}</g>
  <g transform="translate(1189 1320)">{this.getSeatComponent("D", "19", seatColour)}</g>
  <g transform="translate(1132 1320)">{this.getSeatComponent("D", "18", seatColour)}</g>
  <g transform="translate(1075 1320)">{this.getSeatComponent("D", "17", seatColour)}</g>
  <g transform="translate(1135 1230)">{this.getSeatComponent("D", "32", seatColour)}</g>
  <g transform="translate(1192 1230)">{this.getSeatComponent("D", "33", seatColour)}</g>
  <g transform="translate(1249 1230)">{this.getSeatComponent("D", "34", seatColour)}</g>
  <g transform="translate(1306 1230)">{this.getSeatComponent("D", "35", seatColour)}</g>
  <g transform="translate(1363 1230)">{this.getSeatComponent("D", "36", seatColour)}</g>
  <g transform="translate(1420 1230)">{this.getSeatComponent("D", "37", seatColour)}</g>
  <g transform="translate(1477 1230)">{this.getSeatComponent("D", "38", seatColour)}</g>
  <g transform="translate(1534 1230)">{this.getSeatComponent("D", "39", seatColour)}</g>
  <g transform="translate(1591 1230)">{this.getSeatComponent("D", "40", seatColour)}</g>
  <g transform="translate(1648 1230)">{this.getSeatComponent("D", "41", seatColour)}</g>
  <g transform="translate(1705 1230)">{this.getSeatComponent("D", "42", seatColour)}</g>
  <g transform="translate(1762 1230)">{this.getSeatComponent("D", "43", seatColour)}</g>
  <g transform="translate(1819 1230)">{this.getSeatComponent("D", "44", seatColour)}</g>
  <g transform="translate(1738 1140)">{this.getSeatComponent("D", "54", seatColour)}</g>
  <g transform="translate(1681 1140)">{this.getSeatComponent("D", "53", seatColour)}</g>
  <g transform="translate(1624 1140)">{this.getSeatComponent("D", "52", seatColour)}</g>
  <g transform="translate(1567 1140)">{this.getSeatComponent("D", "51", seatColour)}</g>
  <g transform="translate(1510 1140)">{this.getSeatComponent("D", "50", seatColour)}</g>
  <g transform="translate(1453 1140)">{this.getSeatComponent("D", "49", seatColour)}</g>
  <g transform="translate(1396 1140)">{this.getSeatComponent("D", "48", seatColour)}</g>
  <g transform="translate(1339 1140)">{this.getSeatComponent("D", "47", seatColour)}</g>
  <g transform="translate(1282 1140)">{this.getSeatComponent("D", "46", seatColour)}</g>
  <g transform="translate(1225 1140)">{this.getSeatComponent("D", "45", seatColour)}</g>
  <g transform="translate(1395 1050)">{this.getSeatComponent("D", "55", seatColour)}</g>
  <g transform="translate(1455 1050)">{this.getSeatComponent("D", "56", seatColour)}</g>
  <g transform="translate(1515 1050)">{this.getSeatComponent("D", "57", seatColour)}</g>
  <g transform="translate(1575 1050)">{this.getSeatComponent("D", "58", seatColour)}</g>
    </g>);
  }
}


export default withSuspense("", withTranslation(["booking", "common"])(PlaceMarlagne));

